import $ from 'jquery'


/**
 * 初始化导航条宽度
 * @param {*} primaryMenu 
 * @param {*} subMenu 
 */
function initSubMenu(channelContainer, subMenu){
    let primaryMenu = channelContainer.find('.J-primary-menu')
    let height = primaryMenu.height();
    subMenu.css({
        height: height + 2 // 2px border边框
    })
    // 兼容jq1.4.4以下隐藏元素高度问题
    channelContainer.addClass('Hide').removeClass('Hidden')
}


const channelNav = {
    init: () => {

        let $channelContainer = $('.J-cate-nav'),
            $subMenu = $channelContainer.find('.sec-cate');

        initSubMenu($channelContainer, $subMenu);
    }
}

export default channelNav;



// WEBPACK FOOTER //
// ./modules/cate-nav-index/js/channel-nav.js